module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/icon-9228cda75590e68297656b0bb8764466.svg";